export default () => ({
  enrollments: {
    items: {
      rootId: 'root',
      root: {
        id: 'root',
        hasChildren: false,
        isExpanded: true,
        isChildrenLoading: true,
        data: { title: 'root' },
        children: [],
      },
    },
  },
  meta: {
    count: 0,
    maximum_version_number: 1,
    course_attendance_max: null,
    course_session_enforce_attendance_max: false,
    statuses: ['in-progress', 'passed', 'failed', 'no-show', 'incomplete', 'dropped'],
  },
  pagination: {
    page: 1,
    per_page: 50,
    total_records: 0,
  },
});
